import { render, staticRenderFns } from "./siteIndHygieneJournalDetailAppr.vue?vue&type=template&id=09813b7a"
import script from "./siteIndHygieneJournalDetailAppr.vue?vue&type=script&lang=js"
export * from "./siteIndHygieneJournalDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09813b7a')) {
      api.createRecord('09813b7a', component.options)
    } else {
      api.reload('09813b7a', component.options)
    }
    module.hot.accept("./siteIndHygieneJournalDetailAppr.vue?vue&type=template&id=09813b7a", function () {
      api.rerender('09813b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/hea/siteIndHygieneJournalDetailAppr.vue"
export default component.exports